<div
  class="modal fade"
  id="previewFinalReportModal"
  tabindex="-1"
  aria-labelledby="previewFinalReportModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="previewFinalReportModalLabel">
          {{ "previewFinalReport" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        <div *ngIf="previewReportErrorText; else reportGenerated">
          <p class="fs-4">{{ previewReportErrorText }}</p>
        </div>
        <ng-template #reportGenerated>
          <div id="previewFinalReportContent"></div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
